import { Space, Modal, Button } from 'antd';
import { useDialog } from '~/hooks';
import { atom } from 'jotai';
import { useApplicationContext } from '../ApplicationContext';
const signInModal = atom(false);

export function useSignInModal() {
    return useDialog(signInModal);
}

export default function SignInModal() {
    const { loginUrl } = useApplicationContext();
    const { isOpened, closeDialog } = useSignInModal();

    return (
        <Modal
            centered
            open={isOpened}
            destroyOnClose={true}
            onOk={() => {}}
            onCancel={closeDialog}
            footer={null}>
            <div className='flex w-full flex-col items-center justify-center'>
                <h2 className='py-4 text-center text-2xl'> 🔑 Sign In</h2>
                <p>
                    To get the most out of AI Perfect Assistant, we need you to
                    sign in.
                </p>
                <Space
                    direction='vertical'
                    className='my-4 items-center justify-center'>
                    <Button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        type='primary'
                        size='large'
                        href={loginUrl}>
                        Sign In &rarr;
                    </Button>
                </Space>
            </div>
        </Modal>
    );
}
